<template>
<!-- Begin Mailchimp Signup Form -->
  <div id="mc_embed_signup">
    <v-form action="https://entregoals.us3.list-manage.com/subscribe/post?u=55129ccf242113db529117378&amp;id=0805b1531f" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
        <div id="mc_embed_signup_scroll" class="">
          <v-row justify="center">
            <v-col
              cols="12"
              md="4"
            >
            <!-- Name -->
              <div class="mc-field-group">
                <v-text-field
                  dark
                  label="First Name"
                  outlined
                  required
                  class="mr-4"
                  name="FNAME"
                  id="mce-FNAME"
                ></v-text-field>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="5"
            >
            <!-- Email -->
              <div class="mc-field-group">
                <v-text-field
                  dark
                  label="Email"
                  outlined
                  required
                  class="mr-4"
                  name="EMAIL"
                  id="mce-EMAIL"
                ></v-text-field>
              </div>
            </v-col>
              <div id="mce-responses" class="clear">
              <div class="response" id="mce-error-response" style="display:none"></div>
              <div class="response" id="mce-success-response" style="display:none"></div>
            </div>
            <div style="position: absolute; left: -5000px;"
            aria-hidden="true">
              <input type="text"
              name="b_55129ccf242113db529117378_0805b1531f"
              tabindex="-1"
              value="">
            </div>

            <!-- Submit button -->

            <v-col
              cols="12"
              md="3"
            >
              <div class="clear">
                <v-btn
                  dark
                  large
                  type="submit"
                  color="success"
                  class="mt-2"
                  id="mc-embedded-subscribe"
                >
                  Subscribe
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
    </v-form>
  </div>
</template>

<script>
export default {

  name: 'McSignup',

  data() {
    return {

    };
  },
};
</script>

<style lang="css" scoped>
/** {
  border: 1px solid red;
}*/
</style>
